'use client';

export { default } from './Popover';
export * from './Popover';
export { default as popoverClasses } from './popoverClasses';
export * from './popoverClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Popover/index.js
// module id = 553
// module chunks = 25